const INTENTIONAL_LANGUAGE_KEY = 'intentional_language';

export function setIntentionalLanguage(code: string) {
  sessionStorage.setItem(INTENTIONAL_LANGUAGE_KEY, code);
}

export function consumeIntentionalLanguage(): string | null {
  const code = sessionStorage.getItem(INTENTIONAL_LANGUAGE_KEY);
  if (code) sessionStorage.removeItem(INTENTIONAL_LANGUAGE_KEY);
  return code;
}

export function clearIntentionalLanguage() {
  sessionStorage.removeItem(INTENTIONAL_LANGUAGE_KEY);
}
